import { useQuery } from "@tanstack/react-query";
import { client_v2 } from "utils/api";
import Item from "./components/Item";
import { Loader } from "components";

const LastGrnLineBatches = () => {
  const { isLoading, isFetching, data, refetch } = useQuery(
    ["dashboard_newest_grn_line_batches"],
    () => client_v2.get("/stats/dashboard_newest_grn_line_batches"),
    {
      select: (res) => res.data,
      retry: false,
    }
  );
  const is_loading = isLoading || isFetching;
  return (
    <div className="dashboard">
      <div className="history-box__header">
        <span className="title">Ostatnio przyjęte</span>
        {is_loading ? (
          <Loader size="20" />
        ) : (
          <button className="btn btn-default" onClick={refetch}>
            Odśwież
          </button>
        )}
      </div>
      {data?.length > 0 && (
        <ul className="history-box__body">
          {data.map((data) => (
            <Item key={data.id} {...data} />
          ))}
        </ul>
      )}
    </div>
  );
};

export default LastGrnLineBatches;
